module.exports = __webpack_public_path__ + "img/manage.c6f1cf01.svg";